/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import { useCustomer } from "@/src/provider/Customer/CustomerProvider";
import Layout from "../../../../Layouts/Layout";
import LpTrafficAccidentMeta from "./LpTrafficAccidentMeta";
import { getLastPathSplit } from "@/src/services/redirect";
import { landingPagesList } from "@/src/services/landingPagesList";
import LinkedCardBox from "../../../../../components/LinkedCardBox/LinkedCardBox";
import { trafficTeaserCards } from "@/src/services/landingPageService";
import LandingPageTeaser from "../../../../../components/Teaser/LandingPageTeaser";
import React from "react";
import TrafficAccidentCheckin from "../../../../../components/Checkin/TrafficAccidentCheckin/TrafficAccidentCheckin";
import HowItWorksSectionTrafficAccident from "../../../../../components/Sections/TrafficLaw/TrafficAccident/HowItWorksSection/HowItWorksSectionTrafficAccident";
import AttorneySection from "../../../../../components/Sections/Generic/AttorneySection/AttorneySection";
import Container from "../../../../../components/Container/Container";

const LpTrafficAccident = () => {
  const lpKey = getLastPathSplit(location.pathname);
  const keyword = (lpKey && landingPagesList[lpKey]?.keyword) ?? "Verkehrsunfall";
  const headline = (lpKey && landingPagesList[lpKey]?.headline) ?? "Schaden durch Verkehrsunfall erlitten?";
  const { isLoggedIn } = useCustomer();

  return (
    <Layout minimal={!isLoggedIn} clickableLogo={isLoggedIn} backgroundType={"landingpage"}>
      <LpTrafficAccidentMeta keyword={keyword} />
      <LandingPageTeaser
        headline={headline}
        subheadline={"Jetzt effektiv Ihre Rechte nach dem Unfall durchsetzen!"}
        teaserButtonText={"Jetzt starten"}
        teaserButtonLink={isLoggedIn ? "/servicewelt" : "#top-checkin"}
      >
        <LinkedCardBox linkedCards={trafficTeaserCards} />
      </LandingPageTeaser>
      {!isLoggedIn && (
        <Container>
          <TrafficAccidentCheckin idPrefix={"top"} checkinHeading={"Fall schildern und professionelle Hilfe erhalten"} />
        </Container>
      )}
      <HowItWorksSectionTrafficAccident />
      <AttorneySection
        product={"trafficAccident"}
        subheading={"Sie möchten professionell und unkompliziert gegen Ihren Bescheid vorgehen? Wir helfen Ihnen - jederzeit und ortsunabhängig!"}
      />
      {!isLoggedIn && (
        <Container>
          <TrafficAccidentCheckin idPrefix={"bottom"} checkinHeading={"Fall schildern und professionelle Hilfe erhalten"} />
        </Container>
      )}
    </Layout>
  );
};

export default LpTrafficAccident;
